
import axios from "axios";
import { URL_BASE } from "../config/url-server";

const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")


 export const markSupervisionsAsPending = async (start, end, farmId, sectionId, lotId,userId) => {
    const data = {startDate:start,endDate: end, farmId, sectionId, lotId ,userId}
    const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
    try {
      const response = await axios.post(URL_BASE+"task/mark-supervisions-as-pending", data, config)
      const success = response.data?.success || null;
      return success;
    } catch (error) {
      console.error("Error:", error);
      return false;
    }
  };




 
  export const synchronizePending = async (start, end, farmId, sectionId, lotId,userId) => {
    const data = {startDate:start,endDate: end, farmId, sectionId, lotId ,userId}
    const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
    try {
      const response = await axios.post(URL_BASE+"task/synchronize-pending", data, config)
      const success = response.data?.success || null;
      return success;
    } catch (error) {
      console.error("Error:", error);
      return false;
    }
  };



  
export const updateSupervision= async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"task/update-supervision", data, config)
    const responseData = response.data;
    return responseData;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};



export const deleteSupervision = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"task/delete-supervision", data, config)
    const responseData = response.data;
    return responseData;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};








  export default{
    synchronizePending,
    updateSupervision,
    deleteSupervision,
    markSupervisionsAsPending
  }

